import { useContext, useState, useEffect } from "react";
import { AuthContext } from "../useAuth";
import { useUser } from "../api/Users";
import dayjs from "dayjs";
import isBetween from "dayjs/plugin/isBetween";
import relativeTime from "dayjs/plugin/relativeTime";
import { useInterval } from "./useInterval";

dayjs.extend(isBetween);
dayjs.extend(relativeTime);

export const useJoinSession = (session) => {
  const StartTime = session?.StartTime;
  const EndTime = session?.EndTime;
  const now = dayjs();
  const sessionStart = dayjs(StartTime);
  const sessionEnd = dayjs(EndTime);
  const buffer = sessionStart.clone().subtract(3, "minutes");
  const [canJoin, setCanJoin] = useState(now.isBetween(buffer, sessionEnd));
  const [displayText, setDisplayText] = useState("Join");

  // TODO: setDisplayText a few minutes before
  useInterval(
    () => {
      setCanJoin(dayjs().isBetween(buffer, sessionEnd));
      if ((dayjs().isBetween(buffer.subtract(10, "minutes")), buffer))
        setDisplayText(buffer.fromNow());
      else setDisplayText("Join");
    },
    !canJoin ? 1000 : null
  );

  return { canJoin: canJoin, displayText: displayText };
};

// Filters out attendees that aren't equal to the current user id
export const useSessionGuest = (attendees = []) => {
  const [guestUser, setGuestUser] = useState();

  const { user } = useContext(AuthContext);
  let guests = attendees.filter((a) => a.UserId !== user.UserId);

  const { data } = useUser(guests[0]?.UserId);
  useEffect(() => {
    if (data?.User) {
      let u = data?.User;
      u.UserId = guests[0].UserId;
      setGuestUser(data.User);
    }
  }, [data]);

  return guestUser;
};

export const useSessionDate = (session) => {
  let now = dayjs();
  let sessionStart = dayjs(session?.StartTime);
  let sessionEnd = dayjs(session?.EndTime);

  let day, start, end;

  if (now.day() === sessionStart.day()) day = "Today from";
  else day = sessionStart.format("dddd MMM Do");

  start = sessionStart.format("h:mma");
  end = sessionEnd.format("h:mma");

  return `${day} ${start} - ${end}`;
};

export const useSessionValidation = (attendees) => {
  const { user } = useContext(AuthContext);
  if (!attendees) return undefined;
  return attendees.some((a) => a.UserId === user?.UserId);
};
